import { render, staticRenderFns } from "./ListEditorHeader.vue?vue&type=template&id=a8d7a472&scoped=true&"
import script from "./ListEditorHeader.vue?vue&type=script&lang=ts&"
export * from "./ListEditorHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ListEditorHeader.vue?vue&type=style&index=0&id=a8d7a472&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d7a472",
  null
  
)

export default component.exports